import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';

import {
  ONBOARDING_REASON,
  REASON_FIELD_LABEL,
  REASON_OPTIONS,
  REASON_OTHER_FIELD_LABEL,
  REASON_OTHER_REQUIRED_MESSAGE,
  REASON_REQUIRED_MESSAGE,
} from '../../constants/onboardingQueue';

export const requiresOtherText = reason => reason === ONBOARDING_REASON.OTHER;

export const reasonValidationError = (reason, otherText) => {
  if (!reason) return REASON_REQUIRED_MESSAGE;
  if (requiresOtherText(reason) && !String(otherText || '').trim()) {
    return REASON_OTHER_REQUIRED_MESSAGE;
  }
  return '';
};

const ReasonFields = ({
  reason, otherText, disabled, invalid, onReasonChange, onOtherTextChange,
}) => (
  <>
    <Form.Select
      required
      label={REASON_FIELD_LABEL}
      placeholder='Select a reason'
      options={REASON_OPTIONS}
      value={reason || ''}
      disabled={disabled}
      error={invalid && !reason}
      data-testid='queue-reason-select'
      onChange={(event, { value }) => onReasonChange(value)}
    />

    {requiresOtherText(reason) && (
      <Form.Field required error={invalid && !String(otherText || '').trim()}>
        <label htmlFor='queue-reason-other'>{REASON_OTHER_FIELD_LABEL}</label>
        <Input
          id='queue-reason-other'
          value={otherText}
          disabled={disabled}
          data-testid='queue-reason-other'
          onChange={(event, { value }) => onOtherTextChange(value)}
        />
      </Form.Field>
    )}
  </>
);

ReasonFields.propTypes = {
  reason: PropTypes.string,
  otherText: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  onReasonChange: PropTypes.func.isRequired,
  onOtherTextChange: PropTypes.func.isRequired,
};

ReasonFields.defaultProps = {
  reason: null,
  otherText: '',
  disabled: false,
  invalid: false,
};

export default ReasonFields;
